<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import wx from "weixin-js-sdk";

import { wxShareInit } from "./api/home/index";
export default {
  data() {
    return {
      appId: "wx40dd62c93a7dc9dd",
      appSecret: "a0e13e6e9d8fee78ac6b1002a4de0ad7",
    };
  },
  mounted() {
    if(location.pathname === '/'){

      wxShareInit({ url: location.href }).then((res) => {
        this.wxConfig(res);
      });
    }
  },
  methods: {
    wxConfig(params) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: params.shareConfig.appId, // 必填，公众号的唯一标识
        timestamp: params.shareConfig.timestamp, // 必填，生成签名的时间戳
        nonceStr: params.shareConfig.nonceStr, // 必填，生成签名的随机串
        signature: params.shareConfig.signature, // 必填，签名
        jsApiList: [
          "updateAppMessageShareData",
          "updateTimelineShareData",
        ], // 必填，需要使用的JS接口列表，具体可以查看JS接口列表：<https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#63>
      });
      wx.error((res) => {
        console.log("wx:err", res);
      });
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: params.shareContent.shareTitle, // 分享标题，可选
          desc:  params.shareContent.shareDesc, // 分享描述，可选
          link: location.href,
          imgUrl: params.shareContent.shareThumb, // 分享图标，可选 //  link: shareLink, // 分享链接，可选，默认当前页面
          success: function () {
            // 分享成功回调函数，可选
            // sharedSuccessCallback?.() // 有些不支持这种写法，可以写成下面这种
            sharedSuccessCallback && sharedSuccessCallback();
          },
        });
        //分享到朋友圈
        wx.updateTimelineShareData({
          title: 'shareTitle', // 分享标题
          imgUrl: 'shareImgUrl', // 分享图标 //  link: shareLink, // 分享链接
          success: function () {
            sharedSuccessCallback?.();
          },
        });
      
      });
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #303030;
  height: 100%;
  overflow-x: hidden;
}
* {
  margin: 0;
  padding: 0;
}

body,
html {
  height: 100%;
}

a {
  text-decoration: none;
}
</style>
